import { getInitialState } from './index';
import { State, RegistrationForms } from './types';

import { ScheduledEmail } from '@/studio/emailSchedule/store/types';

const mutations = {
  setRegistrationForms(state: State, registrationForms: RegistrationForms) {
    state.registrationForms = registrationForms;
  },
  setFormLoading(state: State, isLoading: boolean) {
    state.isFormLoading = isLoading;
  },
  //[TODO] Move this to a email store
  setRegistrationEmail(state: State, { registrationEmail }: { registrationEmail: ScheduledEmail }) {
    state.registrationEmail = registrationEmail;
  },
  setEmailLoading(state: State, isLoading: boolean) {
    state.isEmailLoading = isLoading;
  },
  resetRegistrationState(state: State) {
    Object.assign(state, getInitialState());
  }
};

export default mutations;
